import React from 'react';
import { string, number, func, shape } from 'prop-types';
import styled from 'styled-components';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';

import StyledText from '../shared/StyledText';
import {
  MAIN_COLOR,
  SMALL_TEXT,
  DESKTOP_SIZE,
  MOBILE_SIZE,
} from '../../constants';

const Range = createSliderWithTooltip(Slider.Range);

const Container = styled.div`
  margin-top: 20px;
  display: grid;
  width: 100%;
  grid-row-gap: 15px;
  grid-template-rows: 1fr 1fr;
  @media (min-width: ${DESKTOP_SIZE}) {
    grid-template-rows: 1fr;
    grid-template-columns: auto 1fr;
    grid-column-gap: 20px;
  }
`;

const StyledLabel = styled(StyledText)`
  grid-row: 1;
  grid-column: 1;
`;

const StyledRange = styled(Range)`
  width: 90%;

  @media (max-width: ${MOBILE_SIZE}) {
    width: 75%;
  }
`;

const StyledValue = styled.div`
  width: 50px;
  text-align: center;
`;

const StyledSliderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .rc-slider-rail {
    background-color: #3b3b3b;
  }

  .rc-slider-track {
    background-color: ${MAIN_COLOR};
  }

  .rc-slider-handle {
    border: none;
    background-color: ${MAIN_COLOR};
    transition: transform 0.2s ease;
  }

  .rc-slider-handle:focus {
    border: none;
    box-shadow: none;
  }

  .rc-slider-handle:active {
    transform: scale(1.3);
  }
`;

const RangeFilter = ({
  name,
  label,
  value,
  updateQuery,
  updateFilterState,
  maxValue,
  minValue,
}) => (
  <Container>
    <StyledLabel size={SMALL_TEXT} isInline isBold>
      {label}
    </StyledLabel>
    <StyledSliderContainer onBlur={() => updateQuery()}>
      <StyledValue>{value.min}</StyledValue>
      <StyledRange
        min={minValue}
        max={maxValue}
        defaultValue={[minValue, maxValue]}
        allowCross={false}
        onChange={value => updateFilterState(name, value)}
      />
      <StyledValue>{value.max}</StyledValue>
    </StyledSliderContainer>
  </Container>
);

RangeFilter.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  value: shape({
    min: number.isRequired,
    max: number.isRequired,
  }).isRequired,
  updateQuery: func.isRequired,
  updateFilterState: func.isRequired,
  maxValue: number.isRequired,
  minValue: number.isRequired,
};

export default RangeFilter;



// WEBPACK FOOTER //
// components/shared/RangeFilter.js